function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export var prepareBaseDialog = function (id, title, idContent, continueText, autoClose) {
  let dialog = document.querySelector(`#${id}`);

  if (dialog) {
    dialog.remove();
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  dialog = document.createElement('dialog');
  dialog.id = id;
  dialog.classList.add('w-8/10', 'overflow-hidden', 'rounded', 'shadow-md');
  dialog.innerHTML = `
        <div class="dialog-content">
            <div class="dialog-header flex justify-between pb-4">
                <h2 class="dialog-title text-lg">${escapeHtml(title)}</h2>
                <button type="button" class="dialog-close" aria-label="Zavřít">×</button>
            </div>
            <div class="dialog-body">
                <div id="${idContent}"></div>
            </div>
        </div>
    `;

  document.body.appendChild(dialog);

  const closeBtn = dialog.querySelector('.dialog-close');

  const onCloseBtnClick = () => dialog.close();
  const onDialogClick = (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  };

  closeBtn.addEventListener('click', onCloseBtnClick);
  dialog.addEventListener('click', onDialogClick);

  dialog.addEventListener('close', function cleanup() {
    closeBtn.removeEventListener('click', onCloseBtnClick);
    dialog.removeEventListener('click', onDialogClick);
    if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
    dialog.removeEventListener('close', cleanup);
  });

  return dialog;
};

export var prepareDeleteDialog = function (model, url, data, hardDelete, title, inactive) {
  const $dialog = prepareBaseDialog('relatedDialog_modal', window.I18n.t(`${model}.dialog.title`) + ' ' + title, 'dataContainer_content', window.I18n.t(`${model}.dialog.continue`), false);

  let last_type = '';
  if (data.length > 0) {
    $('#dataContainer_content').append("<div class=\"container-fluid\">");
    for (var item of Array.from(data)) {
      if (last_type !== item.type) {
        $('#dataContainer_content').append('<h4>' + window.I18n.t(`${model}.dialog.${item.type.toLowerCase()}s`) + '</h4>');
        last_type = item.type;
      }
      $('#dataContainer_content').append(`<div><a href=${item.url} target=\"_new\">${item.text}</a></div>`);
    }
    $('#dataContainer_content').append("</div><hr />");
  }


  $('#dataContainer_content').append(`\
<div class=\"container-fluid btn-group\" data-toggle=\"buttons\"> \
<div class=\"row \"> \
<div class=\"col-md-10 allign-middle\"><h4>` + window.I18n.t(`${model}.dialog.delete_top`) + `</h4></div> \
</div> \
<div class=\"row\" id=\"softDeleteRow\"> \
<div class=\"col-md-2 allign-middle\"> \
<div class=\"btn-group-justified\"> \
<label class=\"btn fm-btn-soft-delete\"> \
<input id=\"relatedDialogSoftDelete\" type=\"radio\" name=\"modal_options\" id=\"option2\" autocomplete=\"off\">` + window.I18n.t(`${model}.dialog.soft`) + `\
</label> \
</div> \
</div> \
<div class=\"col-md-9\">` + window.I18n.t(`${model}.dialog.delete_tip_soft`) + `</div> \
</div> \
<div class=\"row\" id=\"hardDeleteRow\"> \
<div class=\"col-md-2 allign-middle\"> \
<div class=\"btn-group-justified\"> \
<label class=\"btn fm-btn-hard-delete\"> \
<input id=\"relatedDialogHardDelete\" type=\"radio\" name=\"modal_options\" id=\"option3\" autocomplete=\"off\">` + window.I18n.t(`${model}.dialog.hard`) + `\
</label> \
</div> \
</div> \
<div class=\"col-md-9\">` + window.I18n.t(`${model}.dialog.delete_tip_hard`) + `</div> \
</div> \
</div>`);


  const opts = {};

  $dialog.modal(opts);

  // hack to allow gridded buttons - bootstrap won't hide radio in this case
  for (var inp of Array.from($('input[name="modal_options"]', '#dataContainer_content'))) {
    var events;
    inp.style.position = 'absolute';
    inp.style.clip = 'rect(0, 0, 0, 0)';
    inp.style.pointer - (events = 'none');
  }

  if (inactive === true) {
    $('.fm-btn-soft-delete').addClass('disabled');
    $('.fm-btn-soft-delete').click(function (e) {
      e.stopPropagation();
    });
  }

  if (inactive === "hide") {
    $('#softDeleteRow').hide();
  }

  // self made click handling
  return $('#relatedDialog_modal button.btn-default').click(function (e) {
    // nothing has been checked
    if (!($('#relatedDialogHardDelete')[0].checked || (($('#relatedDialogSoftDelete')[0].checked) && (inactive === false)))) {
      e.preventDefault = true;
      window.alert(window.I18n.t(`${model}.dialog.delete_top`));
      return;
    }

    // perform the action
    return $.ajax({
      url,
      beforeSend(xhr) {
        return xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      type: 'POST',
      data: {
        _method: "delete",
        hard_delete: $('#relatedDialogHardDelete')[0].checked
      },
      dataType: 'json',
      success(returnedData) {
        $dialog.modal('hide');
        return window.location.reload(false);
      }
    });
  });
};
        